import { Box, Skeleton, Typography } from "@mui/material";

import GroupIcon from "@mui/icons-material/Group";
import { styled } from "@mui/material/styles";

export const PaddedContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
}));

export const AttendanceCountContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  minWidth: theme.spacing(6),
  maxWidth: theme.spacing(12),
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const AttendanceIcon = styled(GroupIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.secondary.purple,
  flexShrink: 0,
}));

export const AttendanceText = styled(Typography)(({ theme }) => ({
  width: "80%",
}));

export const ContactAvatarSkeleton = styled(Skeleton)(({ theme }) => ({
  width: 36,
  height: 36,
  flexShrink: 0,
  marginRight: theme.spacing(1),
}));

export const ContactSkeletonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  margin: `${theme.spacing(2)} 0`,
}));
